'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _browser = require('@sentry/browser');
var Sentry = _interopRequireWildcard(_browser);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ErrorHandler = function (_PureComponent) {
  _inherits(ErrorHandler, _PureComponent);
  function ErrorHandler() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ErrorHandler);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorHandler.__proto__ || Object.getPrototypeOf(ErrorHandler)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasError: false,
      errorInfo: {},
      eventId: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ErrorHandler, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({
        hasError: true,
        errorInfo: info
      });
      this.props.onError(error, info);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      if (this.state.hasError) {
        console.log(this.state.errorInfo);
        return _react2.default.createElement(_react.Fragment, null, this.props.useSentry && _react2.default.createElement('a', {
          onClick: function onClick() {
            return Sentry.showReportDialog({
              eventId: _this2.state.eventId
            });
          }
        }, 'Report feedback'), this.props.errorElement);
      }
      return this.props.children;
    }
  }], [{
    key: 'getDerivedStateFromError',
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);
  return ErrorHandler;
}(_react.PureComponent);
ErrorHandler.defaultProps = {
  useSentry: false,
  errorElement: _react2.default.createElement('div', null, 'Oh no, Something went wrong! :( '),
  onError: function onError(error, info) {
    console.log(error, info);
    if (undefined.props.useSentry) {
      Sentry.withScope(function (scope) {
        scope.setExtras(info);
        var eventId = Sentry.captureException(error);
        undefined.setState({
          eventId: eventId
        });
      });
    }
  }
};
exports.default = ErrorHandler;